import sha512 from 'js-sha512'
import StringBuilder from 'string-builder'

export const convertSHA= () => {    

  var fecha = formatDate();
    var bytes = new Buffer("SyKe22018*"+ fecha +'Ch4tT0kEn-512', "ascii");
   
    var stream = new Uint8Array(sha512.arrayBuffer(bytes));

    const sb = new StringBuilder();
    for (let i = 0; i < stream.length; i++) {
      sb.appendFormat("{0}",numHex(stream[i]));
    }
    //console.log(sb.toString());

    return(sb.toString());
    //return '4571885df3cd539938154159c00484c1d0a866fbd9ed86b064852e13a8baf6592d56081b74432dd94fc0e9eae3a1ccdc6ae77634a3bf9845baeb4ab9edf93a6e'
  };

  function numHex(s)
  {
      var a = s.toString(16);
      if ((a.length % 2) > 0) {
          a = "0" + a;
      }
      return a;
  }

  function formatDate() {
    var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
  
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
  
    return [month, day,year].join('/') ;
  }